import { useContext, useEffect, useState } from "react";
import {
  Box,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { azureLanguages } from "../translate2";
import { AvailableLangs } from "../types";
import { LangChangeContext, useSettings } from "../contexts";

export default function SettingsPanel() {
  const { setLangChangeUseEffect } = useContext(LangChangeContext);
  const [languageList, setLanguageList] = useState<AvailableLangs>({
    en: { name: "English", nativeName: "English", dir: "ltr" },
    ja: { name: "Japanese", nativeName: "日本語", dir: "ltr" },
  });

  const { settings, setSettings } = useSettings();

  useEffect(() => {
    azureLanguages().then((azureList) => {
      if (azureList && azureList.translation) {
        setLanguageList(azureList.translation);
      }
    });
  }, []);

  const handleChange = (settingId: string, event: SelectChangeEvent) => {
    const newSettings = { ...settings };
    const keyTyped = settingId as keyof typeof newSettings;
    newSettings[keyTyped] = event.target.value;
    setSettings(newSettings);
    setLangChangeUseEffect(false);
  };

  return (
    <Container maxWidth="xs">
      <Box
        sx={{ pt: 1, pb: 1 }}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <FormControl size="small" fullWidth>
          <InputLabel id="l-lang">Left Language</InputLabel>
          <Select
            labelId="l-lang"
            label="Left Language"
            defaultValue={"en"}
            value={settings.leftLang}
            onChange={(e) => handleChange("leftLang", e)}
          >
            {Object.keys(languageList).map((key, i) => (
              <MenuItem value={key} key={i}>
                {languageList[key].name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl size="small" fullWidth>
          <InputLabel id="r-lang">Right Language</InputLabel>
          <Select
            labelId="r-lang"
            label="Right Language"
            defaultValue={"ja"}
            value={settings.rightLang}
            onChange={(e) => handleChange("rightLang", e)}
          >
            {Object.keys(languageList).map((key, i) => (
              <MenuItem value={key} key={i}>
                {languageList[key].name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Container>
  );
}
